import countriesJson from '@/utilities/constants/countryList.json';

export interface Country {
  code: string;
  dial_code: string;
  name: string;
}

export const countries = countriesJson as Country[];
